import React, { useState, useMemo } from "react";
import employeeLogo from "../../../Assets/logo/wbclogo.svg";
import JobApplicationModal from "./JobApplicationModal";

const jobData = [
  {
    title: "Marketing Executive",
    type: "Full-TIME",
    salary: "12,000 - 15,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Java Trainer",
    type: "Full-TIME",
    salary: "13,000 - 25,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "MERN Stack Trainer",
    type: "Full-TIME",
    salary: "13,000 - 18,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Student Counselor",
    type: "Full-TIME",
    salary: "12,000 - 17,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Senior Marketing Executive",
    type: "Full-TIME",
    salary: "18,000 - 28,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Field Officer",
    type: "Full-TIME",
    salary: "10,000 - 15,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },

  {
    title: "Frontend Mentor",
    type: "Part-TIME",
    salary: "8,000 - 12,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Backend Engineer",
    type: "Full-TIME",
    salary: "20,000 - 35,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "Content Writer",
    type: "Part-TIME",
    salary: "6,000 - 10,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "SEO Specialist",
    type: "Full-TIME",
    salary: "10,000 - 18,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "DevOps Intern",
    type: "Internship",
    salary: "4,000 - 7,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
  {
    title: "QA Engineer",
    type: "Full-TIME",
    salary: "12,000 - 20,000",
    company: "Web_Bocket Classes",
    location: "Bhubaneswar",
    logo: employeeLogo,
  },
];

const ITEMS_PER_PAGE = 6;

const JobOpennings = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(jobData.length / ITEMS_PER_PAGE));

  const currentJobs = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return jobData.slice(start, start + ITEMS_PER_PAGE);
  }, [currentPage]);

  const openModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setSelectedJob(null);
    setIsModalOpen(false);
  };

  const goToPage = (p) => {
    const page = Math.min(Math.max(1, p), totalPages);
    setCurrentPage(page);
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-12 lg:py-16">
      {/* background glow */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 top-8 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -right-24 bottom-8 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* header */}
        <div className="text-center mb-8" data-aos="fade-up">
          <p className="inline-flex items-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm text-[#5989C8] font-medium backdrop-blur-md">
            Our Jobs
          </p>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold text-white">
            Current Job Openings
          </h2>
          <p className="mt-3 text-sm md:text-base text-slate-300/90 max-w-2xl mx-auto">
            We're hiring! Browse the openings below and click Apply to send your
            application.
          </p>
        </div>

        {/* grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentJobs.map((job, idx) => (
            <article
              key={idx}
              className="relative flex flex-col justify-between rounded-2xl bg-white/4 border border-white/8 backdrop-blur-md p-5 shadow-lg shadow-slate-950/40 hover:shadow-[#064585]/30 transition-all duration-200"
              data-aos="fade-up"
              data-aos-delay={idx * 40}
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <img
                    src={job.logo}
                    alt={`${job.company} logo`}
                    className="w-14 h-14 rounded-lg bg-slate-900/30 p-1"
                  />
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-white">
                    {job.title}
                  </h3>
                  <p className="text-sm text-slate-300 mt-1">
                    {job.company} •{" "}
                    <span className="text-slate-200">{job.location}</span>
                  </p>

                  <div className="mt-3 flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#064585]/20 text-[#cfe8ff] border border-[#064585]/10">
                      {job.type}
                    </span>
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-500/10 text-emerald-200 border border-emerald-500/10">
                      ₹{job.salary}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-white/6 flex items-center justify-between gap-3">
                <p className="text-sm text-slate-300 line-clamp-2">
                  We are seeking motivated individuals who love teaching and
                  building products—join to learn, mentor, and grow.
                </p>

                <div className="flex flex-col items-end gap-2">
                  <button
                    onClick={() => openModal(job)}
                    className="inline-flex items-center gap-2 rounded-full bg-[#064585] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-[#064585]/40 hover:bg-[#033465] transition-all duration-200"
                    aria-label={`Apply for ${job.title}`}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* pagination */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-slate-300">
            Showing{" "}
            <span className="text-white font-medium">
              {(currentPage - 1) * ITEMS_PER_PAGE + 1}
            </span>{" "}
            -{" "}
            <span className="text-white font-medium">
              {Math.min(currentPage * ITEMS_PER_PAGE, jobData.length)}
            </span>{" "}
            of <span className="text-white font-medium">{jobData.length}</span>{" "}
            jobs
          </div>

          <nav
            className="flex items-center gap-2"
            role="navigation"
            aria-label="Pagination"
          >
            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPage === 1
                  ? "text-slate-500 bg-white/2 cursor-not-allowed"
                  : "text-white bg-[#064585] hover:bg-[#033465]"
              }`}
            >
              Prev
            </button>

            {/* page numbers  */}
            <div className="hidden sm:flex items-center gap-1">
              {Array.from({ length: totalPages }).map((_, i) => {
                const page = i + 1;
                if (
                  page === 1 ||
                  page === totalPages ||
                  Math.abs(page - currentPage) <= 1
                ) {
                  return (
                    <button
                      key={page}
                      onClick={() => goToPage(page)}
                      className={`px-3 py-2 rounded-md text-sm font-medium ${
                        currentPage === page
                          ? "bg-white/10 text-white"
                          : "text-slate-300 bg-white/2 hover:bg-white/6"
                      }`}
                      aria-current={currentPage === page ? "page" : undefined}
                    >
                      {page}
                    </button>
                  );
                } else if (
                  (page === 2 && currentPage > 3) ||
                  (page === totalPages - 1 && currentPage < totalPages - 2)
                ) {
                  return (
                    <span key={page} className="px-2 text-slate-500">
                      …
                    </span>
                  );
                }
                return null;
              })}
            </div>

            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPage === totalPages
                  ? "text-slate-500 bg-white/2 cursor-not-allowed"
                  : "text-white bg-[#064585] hover:bg-[#033465]"
              }`}
            >
              Next
            </button>
          </nav>
        </div>

        <div className="mt-4 text-center">
          <p className="text-sm text-slate-400">
            Can't find the right fit? Send your CV to{" "}
            <a
              href="mailto:hr.webbocket@gmail.com"
              className="text-white font-medium"
            >
              hr.webbocket@gmail.com
            </a>
          </p>
        </div>
      </div>

      {isModalOpen && (
        <JobApplicationModal job={selectedJob} onClose={closeModal} />
      )}
    </section>
  );
};

export default JobOpennings;
